import { render, staticRenderFns } from "./property-drawer.vue?vue&type=template&id=a0f0ea5a&scoped=true&"
import script from "./property-drawer.vue?vue&type=script&lang=ts&"
export * from "./property-drawer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0f0ea5a",
  null
  
)

export default component.exports